import { useClients } from '../../hooks/useClients';
import { Button } from '../common';
import ResponsiveSelect from '../common/ResponsiveSelect';
import { Client } from '../../types';

interface ReportFiltersProps {
  reportType: string;
  filters: any;
  onFilterChange: (filters: any) => void;
  onClearFilters: () => void;
}

export default function ReportFilters({
  reportType,
  filters,
  onFilterChange,
  onClearFilters,
}: ReportFiltersProps) {
  const { data: clientsData } = useClients({ limit: 100 });

  const showClientFilter = true;
  const showDateFilters = ['inward', 'outward', 'inventory', 'additional-space', 'billing'].includes(reportType);
  const showProductFilters = ['inventory', 'inward', 'outward', 'damage'].includes(reportType);
  const showStatusFilter = reportType === 'additional-space';
  const showBillingStatusFilter = reportType === 'billing';

  return (
    <div>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        {/* Client Filter */}
        {showClientFilter && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Client</label>
            <ResponsiveSelect
              options={(clientsData?.data || []).map((client: Client) => ({ value: client.id, label: client.companyName }))}
              value={filters.clientId || ''}
              onChange={(val) => onFilterChange({ clientId: val ? parseInt(val) : undefined })}
              placeholder="All Clients"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-500"
            />
          </div>
        )}

        {/* Date From */}
        {showDateFilters && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Date From</label>
            <input
              type="date"
              value={filters.dateFrom || ''}
              onChange={(e) => onFilterChange({ dateFrom: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-500"
            />
          </div>
        )}

        {/* Date To */}
        {showDateFilters && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Date To</label>
            <input
              type="date"
              value={filters.dateTo || ''}
              onChange={(e) => onFilterChange({ dateTo: e.target.value })}
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-500"
            />
          </div>
        )}

        {/* Product Description */}
        {showProductFilters && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Product</label>
            <input
              type="text"
              value={filters.productDescription || ''}
              onChange={(e) => onFilterChange({ productDescription: e.target.value })}
              placeholder="Product description"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-500"
            />
          </div>
        )}

        {/* Batch No */}
        {showProductFilters && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Batch No</label>
            <input
              type="text"
              value={filters.batchNo || ''}
              onChange={(e) => onFilterChange({ batchNo: e.target.value })}
              placeholder="Batch number"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-500"
            />
          </div>
        )}

        {/* Status Filter for Additional Space */}
        {showStatusFilter && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Status</label>
            <ResponsiveSelect
              options={[
                { value: 'active', label: 'Active' },
                { value: 'released', label: 'Released' },
              ]}
              value={filters.status || ''}
              onChange={(val) => onFilterChange({ status: val || undefined })}
              placeholder="All Status"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-500"
            />
          </div>
        )}

        {/* Status Filter for Billing */}
        {showBillingStatusFilter && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Invoice Status</label>
            <ResponsiveSelect
              options={[
                { value: 'draft', label: 'Draft' },
                { value: 'sent', label: 'Sent' },
                { value: 'paid', label: 'Paid' },
                { value: 'cancelled', label: 'Cancelled' },
              ]}
              value={filters.status || ''}
              onChange={(val) => onFilterChange({ status: val || undefined })}
              placeholder="All Statuses"
              className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-500"
            />
          </div>
        )}

        {/* Clear Filters Button */}
        <div className="flex items-end">
          <Button variant="secondary" onClick={onClearFilters} fullWidth>
            <i className="fas fa-times mr-2"></i>
            Clear Filters
          </Button>
        </div>
      </div>
    </div>
  );
}